module.exports = __webpack_public_path__ + "static/media/annaspathtopurchase.d3e08a64.png";